










































import VueOptions from '@utils/VueOptions'
import CreativeEditor from '@ui/Creative/CreativeEditor'
import UpdateLineItemDiscountTriggerModal from '@triggers/CheckoutWizard/UpdateLineItemDiscountTriggerModal'
import UpdateAddonDiscountTriggerModal from '@triggers/CheckoutWizard/UpdateAddonDiscountTriggerModal'

import UpdateOriginalPriceTriggerModal from '@triggers/CheckoutWizard/UpdateOriginalPriceTriggerModal'
import UpdateOriginalPayoutTriggerModal from '@triggers/CheckoutWizard/UpdateOriginalPayoutTriggerModal'
import UpdateAddonOriginalPriceTriggerModal from '@triggers/CheckoutWizard/UpdateAddonOriginalPriceTriggerModal'
import UpdateAddonOriginalPayoutTriggerModal from '@triggers/CheckoutWizard/UpdateAddonOriginalPayoutTriggerModal'

settings =
  name: "CampaignScheduleEventEdit"

  resources:
    offer:
      resourceName: "offer"
      slug: "offers/:offerId"
    purchase_order:
      resourceName: "purchase_order"
      slug: "purchase_orders/:offer.purchase_order_id"
      fetch: false

  vue:
    components: {
      CreativeEditor,
      UpdateLineItemDiscountTriggerModal,
      UpdateAddonDiscountTriggerModal,
      UpdateOriginalPriceTriggerModal,
      UpdateOriginalPayoutTriggerModal,
      UpdateAddonOriginalPriceTriggerModal,
      UpdateAddonOriginalPayoutTriggerModal,
    }

    data: ->
      creativeEditorModal:
        show: true

    computed:
      actionsForCreativeEditor: ->
        {
          @removeLineItem,
          @updateLineItemQuantity,
          @updateActivationDate,
          @addAddonLineItem,
          @removeAddon,
          @hiUpdateAddonQuantityFn,
          @promptUpdateLineItemDiscount,
          @promptUpdateAddonDiscount,
          @updateOriginalPriceTrigger,
          @updateOriginalPayoutTrigger,
          @updateAddonOriginalPriceTrigger,
          @updateAddonOriginalPayoutTrigger,
          @setVariable
        }

      event: -> @ctxEvent @offer
      eventId: -> @offer.event_id
      eventLineItems: -> @offer?.purchase_order_line_items

    methods:
      onPurchaseUpdateAddonQuantity: ->
        @fetch('offer')

      removeLineItem: (lineItem) ->
        payloadOptions = { line_item_id: lineItem.id }
        @triggerResource 'purchase_order', 'remove_line_item', payloadOptions
      onPurchaseOrderRemoveLineItem: ->

      removeAddon: (lineItem, addon) ->
        payloadOptions = { line_item_id: lineItem.id, addon_id: addon.id }
        @triggerResource 'purchase_order', 'remove_addon_from_line_item', payloadOptions
      onPurchaseOrderRemoveAddonFromLineItem: ->

      addAddonLineItem: (lineItem, pricing_model) ->
        payload = { line_item_id: lineItem.id, pricing_model }
        @triggerResource 'purchase_order', 'add_addon_line_item', payload
      onPurchaseOrderAddAddonLineItem: ->

      updateLineItemQuantity: (lineItem) ->
        payload = { line_item_id: lineItem.id, amount: parseInt(lineItem.quantity) }
        @triggerResource 'purchase_order', 'update_quantity', payload
      onPurchaseOrderUpdateQuantity: ->

      updateActivationDate: (lineItem) ->
        [starts_at, ends_at] = @activationDate
        payload = { line_item_id: lineItem.id, starts_at, ends_at }
        @triggerResource 'purchase_order', 'update_activation_date', payload
      onPurchaseOrderUpdateActivationDate: ->

      hiUpdateAddonQuantityFn: (lineItem) ->
        (addon) =>
          payload = { line_item_id: lineItem.id, addon_id: addon.id, amount: parseInt(addon.quantity) }
          @triggerResource 'purchase_order', 'update_addon_quantity', payload
      onPurchaseOrderUpdateAddonQuantity: ->

      promptUpdateLineItemDiscount: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateLineItemDiscountTrigger.fire(payloadOptions, modalOptions)
      onPurchaseOrderUpdateLineItemDiscount: ->
        @$refs.updateLineItemDiscountTrigger.close()

      promptUpdateAddonDiscount: (lineItem, addon) ->
        payloadOptions = { line_item_id: lineItem.id, addon_id: addon.id }
        modalOptions = { addon }
        @$refs.updateAddonDiscountTrigger.fire(payloadOptions, modalOptions)
      onPurchaseOrderUpdateAddonDiscount: ->
        @$refs.updateAddonDiscountTrigger.close()
        @creativeEditorModal.show = true

      updateOriginalPriceTrigger: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateOriginalPriceTrigger.fire(payloadOptions, modalOptions)
      onPurchaseOrderUpdateOriginalPrice: ->
        @$refs.updateOriginalPriceTrigger.close()

      updateOriginalPayoutTrigger: (lineItem) ->
        payloadOptions =
          line_item_id: lineItem.id
        modalOptions = { lineItem }
        @$refs.updateOriginalPayoutTrigger.fire(payloadOptions, modalOptions)
      onPurchaseOrderUpdateOriginalPayout: ->
        @$refs.updateOriginalPayoutTrigger.close()

      updateAddonOriginalPriceTrigger: (lineItem, addon) ->
        payloadOptions =
          line_item_id: lineItem.id
          addon_id: addon.id
        modalOptions = { lineItem, addon }
        @$refs.updateAddonOriginalPriceTrigger.fire(payloadOptions, modalOptions)
      onPurchaseOrderUpdateAddonOriginalPrice: ->
        @$refs.updateAddonOriginalPriceTrigger.close()

      updateAddonOriginalPayoutTrigger: (lineItem, addon) ->
        payloadOptions =
          line_item_id: lineItem.id
          addon_id: addon.id
        modalOptions = { lineItem, addon }
        @$refs.updateAddonOriginalPayoutTrigger.fire(payloadOptions, modalOptions)
      onPurchaseOrderUpdateAddonOriginalPayout: ->
        @$refs.updateAddonOriginalPayoutTrigger.close()

      setVariable: (lineItem, name, value) ->
        @triggerResource 'purchase_order', 'set_variable', { line_item_id: lineItem.id, name, value }
      onPurchaseOrderSetVariable: ->

export default VueOptions.vue settings
